module.exports = "/_next/static/images/CommitmentToSafety-e43d6b43611428afdce4f7dd82e922dd.webp";